export function getErrorMessage(error: any) {
  if (!!error?.response?.data) {
    return error?.response?.data;
  } else if (!!error?.message) {
    return error?.message;
  }
  return undefined;
}
